import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import styled from "../style.module.css";
import { COPPER, TEAL, GREEN, AXIS_TICK, GRID_STROKE, TOOLTIP_STYLE } from "./theme";

// Full-width user-growth chart backed by the only real time-series.
const GrowthChart = ({ data }) => (
  <section className={styled.growthSection}>
    <h3 className={styled.chartTitle}>User Growth · Monthly</h3>
    {Array.isArray(data) && data.length > 0 ? (
      <div className={styled.growthChart}>
        <ResponsiveContainer width="100%" height={280} minWidth={0}>
          <AreaChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: -8 }}>
            <defs>
              <linearGradient id="gSignups" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={COPPER} stopOpacity={0.35} />
                <stop offset="100%" stopColor={COPPER} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke={GRID_STROKE} vertical={false} />
            <XAxis dataKey="label" tick={AXIS_TICK} tickLine={false} axisLine={false} />
            <YAxis tick={AXIS_TICK} tickLine={false} axisLine={false} width={40} allowDecimals={false} />
            <Tooltip {...TOOLTIP_STYLE} />
            <Legend wrapperStyle={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }} />
            <Area type="monotone" dataKey="signups" name="New Signups" stroke={COPPER} strokeWidth={2} fill="url(#gSignups)" dot={false} />
            <Area type="monotone" dataKey="mau" name="Monthly Active" stroke={TEAL} strokeWidth={2} fillOpacity={0} dot={false} />
            <Area type="monotone" dataKey="dau" name="Daily Active" stroke={GREEN} strokeWidth={2} fillOpacity={0} dot={false} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    ) : (
      <p className={styled.emptyHint}>No historical user data yet — populates as users sign up and stream.</p>
    )}
  </section>
);

export default GrowthChart;
